import * as net from 'util/Net';

export function requestAccess(id: string): Promise<{}> {
  return net.postJSONPromise({
    url: '/1/api/auth:request-access',
    data: {id},
  });
}
